import { PageLayout } from "@/components/layout/PageLayout";

const Cookies = () => {
  return (
    <PageLayout>
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-4">Politica de Cookie-uri – OptiRO.ai (MVP)</h1>
        <p className="text-muted-foreground mb-8">Ultima actualizare: Februarie 2026</p>

        <div className="prose prose-slate dark:prose-invert max-w-none space-y-8">
          <p className="text-muted-foreground leading-relaxed">
            Această Politică explică modul în care OptiRO.ai utilizează cookie-uri și tehnologii similare în versiunea actuală MVP (Minimum Viable Product).
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Pentru întrebări: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Ce sunt cookie-urile?</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Cookie-urile sunt fișiere mici de text stocate în browserul utilizatorului atunci când accesează un site web. Ele ajută la:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Funcționarea corectă a site-ului</li>
              <li>Îmbunătățirea experienței utilizatorului</li>
              <li>Analizarea traficului</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Ce tipuri de cookie-uri folosim în MVP</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              În versiunea actuală OptiRO.ai folosim doar următoarele categorii:
            </p>

            <div className="space-y-4">
              <div className="bg-muted/50 p-4 rounded-lg">
                <h3 className="font-semibold text-foreground mb-2">2.1 Cookie-uri strict necesare (obligatorii)</h3>
                <p className="text-muted-foreground text-sm mb-2">
                  Acestea sunt esențiale pentru funcționarea site-ului. Pot include:
                </p>
                <ul className="list-disc list-inside text-muted-foreground text-sm space-y-1">
                  <li>Cookie-uri de sesiune</li>
                  <li>Securitate</li>
                  <li>Protecție anti-abuz</li>
                  <li>Funcționare formulare</li>
                </ul>
                <p className="text-muted-foreground text-sm mt-2">⚠️ Aceste cookie-uri nu pot fi dezactivate.</p>
              </div>

              <div className="bg-muted/50 p-4 rounded-lg">
                <h3 className="font-semibold text-foreground mb-2">2.2 Cookie-uri de analiză (dacă sunt activate)</h3>
                <p className="text-muted-foreground text-sm mb-2">
                  Putem utiliza instrumente de analiză pentru a înțelege:
                </p>
                <ul className="list-disc list-inside text-muted-foreground text-sm space-y-1">
                  <li>Numărul de vizitatori</li>
                  <li>Paginile accesate</li>
                  <li>Durata vizitelor</li>
                  <li>Interacțiunea cu formularul de scanare</li>
                </ul>
                <p className="text-muted-foreground text-sm mt-2">Aceste date sunt colectate agregat și nu identifică direct utilizatorii.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. Ce NU folosim în MVP</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">În versiunea actuală:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>❌ Nu folosim cookie-uri de publicitate comportamentală</li>
              <li>❌ Nu vindem date către terți</li>
              <li>❌ Nu realizăm profilare agresivă</li>
              <li>❌ Nu folosim rețele externe de ads</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Temeiul legal</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Conform legislației UE (GDPR + Directiva ePrivacy):</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Cookie-urile strict necesare sunt activate automat</li>
              <li>Cookie-urile analitice (dacă există) se bazează pe consimțământ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Cum poți controla cookie-urile</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">Utilizatorul poate:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Șterge cookie-urile din browser</li>
              <li>Bloca cookie-uri viitoare</li>
              <li>Dezactiva cookie-uri din setările browserului</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">
              Instrucțiuni disponibile în: Chrome / Firefox / Edge / Safari – secțiunea Privacy & Security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Durata de stocare</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Cookie-urile de sesiune sunt șterse automat la închiderea browserului</li>
              <li>Cookie-urile persistente (dacă sunt utilizate) au durată limitată</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Servicii terțe</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Pentru funcționarea MVP-ului este posibil să folosim:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Infrastructură cloud</li>
              <li>Servicii de procesare AI</li>
              <li>Instrumente tehnice de analiză</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Aceste servicii respectă standarde de securitate și confidențialitate.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">8. Actualizări ale politicii</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Această politică poate fi actualizată odată cu:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li>Lansarea versiunii complete</li>
              <li>Introducerea sistemului de abonamente</li>
              <li>Integrarea plăților</li>
              <li>Activarea monitorizării continue</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-4">Orice modificare va fi publicată pe această pagină.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">9. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              Pentru orice întrebare legată de cookie-uri: 📧 <a href="mailto:contactoptiro@gmail.com" className="text-primary hover:underline">contactoptiro@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </PageLayout>
  );
};

export default Cookies;
